/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query SenderRouteReadQuery($type: CUSTOMER_TYPE!, $take: PositiveInt, $skip: Int, $search: String, $filter: JSONObject) {
    SenderRouteRead(type: $type, take: $take, skip: $skip, search: $search, filter: $filter) {
      id,
      createdAt,
      updatedAt,
      displayName,
      type,
      message,
      status,
      _totalCount,
      Account {
        email
        displayName
      }
      SenderRoutePlan {
        id,
        Mcc {
          mcc
        },
        Mnc {
          mnc,
          network
        }
      }
    }
  }
`
